import { render, staticRenderFns } from "./TipoResultado.vue?vue&type=template&id=f942258c&scoped=true&"
import script from "./TipoResultado.vue?vue&type=script&lang=js&"
export * from "./TipoResultado.vue?vue&type=script&lang=js&"
import style0 from "./TipoResultado.vue?vue&type=style&index=0&id=f942258c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f942258c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VSkeletonLoader})
